import React, { useContext, useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { LocalesContext } from "../../contexts/LocalesContext";
import { MachineContext } from "../../contexts/MachineContext";
import CardComponent from "../../components/CardComponent";
import ConfResumeComponent from "../../miplus/components/ConfResumeComponent";
import SessionChartComponent from "../../miplus/components/SessionChartComponent";
import { getRequest } from "../../utils/requests";
import MapComponent from "../../components/MapComponent";

const CHART_TIME_LAST_HOURS = 4

export default function MachineScreen(props) {
  const { t, translations } = useContext(LocalesContext);
  const [snap, setSnap] = useState(null);
  const [preset, setPreset] = useState(null);
  const [geolocation, setGeolocation] = useState(null);
  const { machineParams } = useContext(MachineContext);

  useEffect(() => {
    // esecuzione iniziale
    getMachineSnapshots();
    const interval = setInterval(() => getMachineSnapshots(), 10000);
    return () => clearInterval(interval);
  }, []);

  const getMachineSnapshots = () => {
    getRequest(
      props.apis.machines_snapshots_api,
      {
        apis_auth_token: props.apis.auth_token,
        uuid: props.machine_uuid,
        to_hours: CHART_TIME_LAST_HOURS,
        per_page: 500
      },
      (response) => {
        if (response.result) {
          const snapshots = response.payload.snapshots.reverse();
          setSnap(snapshots);
        }
      }
    );

    getRequest(
      props.apis.machines_snapshots_api,
      {
        apis_auth_token: props.apis.auth_token,
        uuid: props.machine_uuid,
        typology: "preset_loaded",
        to_hours: 99999,
        per_page: 1
      },
      (response) => {
        if (response.result && response.payload.snapshots[0]) {
          const preset_uuid = response.payload.snapshots[0].value_string;

          getRequest(
            props.apis.presets_show_api,
            {
              apis_auth_token: props.apis.auth_token,
              preset_uuid: preset_uuid,
            },
            (response) => {
              if (response.result) {
                const preset = response.payload.preset;
                setPreset(preset);
              }
            }
          );
        }
      }
    );

    getRequest(
      props.apis.snapshots_index_api,
      {
        apis_auth_token: props.apis.auth_token,
        machine_uuid: props.machine_uuid,
        typology: "geolocation_retrieve",
      },
      (response) => {
        if (response.result && response.payload.snapshots[0]) {
          const geo = JSON.parse(response.payload.snapshots[0].value_string);
          setGeolocation(geo);
        }
      }
    );
  };

//   console.log('snap:', snap);
// console.log('geolocation:', geolocation); 
// console.log('preset:', preset);

  // Non mostrare il container se non ci sono dati da visualizzare
  if (!snap?.length && !geolocation && !preset) {
    return (
      <div className="c-message">
            <div className="c-message__title">{ t('application.strings.no_data_available') }</div>
      </div>
    );
  }

  return (
    <div>
      {snap && snap.length > 0 && (
        <CardComponent
          title={t("application.titles.session_work_history")}
        >
          <SessionChartComponent snap={snap} />
        </CardComponent>
      )}
      
      {preset && (
          <CardComponent
            title={t("application.titles.last_session_preset")}
          >
            <div className="row row--ais">
              <div className="col-6">
                <ConfResumeComponent configuration={preset.params} numeroFile={machineParams?.setup?.numeroFile} />
              </div>
              {geolocation && (
              <div className="col-3">
                <MapComponent coords={geolocation} />
              </div>
              )}
            </div>
          </CardComponent>
      )}

    </div>
  );
}

MachineScreen.propTypes = {
  goTo: PropTypes.func,
};

MachineScreen.defaultProps = {
  goTo: () => {},
};